module.exports = __webpack_public_path__ + "img/qwzlogo.e2857435.svg";